import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import VueI18n from "vue-i18n";

Vue.use(Vuetify);
Vue.use(VueI18n);

// / Translation provided by Vuetify (javascript)
import ru from "vuetify/lib/locale/ru";
import en from "vuetify/lib/locale/en";
import he from "vuetify/lib/locale/he";

const messages = {
  en: {
    $vuetify: {
      accounts: {
        pageTexts: {
          mainTitle: "Personal cabinet of",
          login: {
            loginLabel: "Login",
            sendSms: "Send SMS",
            call: "Call",
            resend: "Resend OTP",
          },
          userSelect: "Select User",
          options: {
            account: "Account",
            abroad: "Abroad",
          },
        },
      },
      account: {
        accountOptionButtons: {
          users: "Users",
          payments: "Payments",
          profile: "My details",
        },
      },
      user: {
        userOptionButtons: {
          profile: "My Details",
          subscriptions: "Packages",
          devices: "Devices",
          numbers: "Numbers",
          calls: "Calls",
          changeSim: "Change SIM",
        },
        userProfileFields: {
          fullName: "Full name",
          address: "Address",
          email: "Email",
          phoneNumber: "Phone number",
          identification: "ID",
        },
        userCalls: {
          voicemail: "Voicemail",
          speedDial: "Speed dial",
          callerId: "Caller ID",
          unlockPrivate: "Unlock private number",
          callRecord: "Call record",
          reports: "Reports",
        },
      },
    },
  },
  ru: {
    $vuetify: {
      accounts: {
        pageTexts: {
          mainTitle: "Личный кабинет",
          login: {
            loginLabel: "Войти",
            sendSms: "Отправить СМС",
            call: "Звонок по телефону ",
            resend: "Повторить отправку",
          },
          options: {
            account: "Профиль",
            abroad: "За границей",
          },
          userSelect: "Выбрать пользователя",
        },
      },
      account: {
        accountOptionButtons: {
          users: "Пользователи",
          payments: "Платежи",
          profile: "Мои данные",
        },
      },
      user: {
        userOptionButtons: {
          profile: "Мои данные",
          subscriptions: "Пакеты",
          devices: "Устройства",
          numbers: "Номера телефона",
          calls: "Разговоры",
          changeSim: "Сменить SIM",
        },
      },
    },
  },

  he: {
    $vuetify: {
      commonTexts: {
        buttons: {
          save: "שמור",
          cancel: "סגור",
          confirm: "אישור",
          removeService: "הסר שירות",
          remove: "הסר",
        },
        options: {
          sendToMail: "",
          servicePrice: "",
          allNumbers: "",
          selectNumbers: "",
          agreeToTerms: "",
        },
      },
      accounts: {
        pageTexts: {
          mainTitle: "האזור האישי של",
          login: {
            loginLabel: "התחבר",
            sendSms: "SMS שלח",
            call: "שיחה",
            resend: "שלח שוב",
          },
          userSelect: "בחירת משתמש",
          options: {
            account: "החשבון שלי",
            abroad: "חו״ל",
          },
        },
      },
      account: {
        accountOptionButtons: {
          users: "משתמשים",
          payments: "תשלומים",
          profile: "הפרטים שלי",
        },
      },
      user: {
        userOptionButtons: {
          profile: "הפרטים שלי",
          subscriptions: "חבילות",
          devices: "מכשירים",
          numbers: "מספרים",
          calls: "שיחות",
          changeSim: "החלף סים",
        },
        userProfileFields: {
          fullName: "Full name",
          address: "Address",
          email: "Email",
          phoneNumber: "Phone number",
          identification: "ID",
        },
        userCalls: {
          voicemail: "Voicemail",
          speedDial: "Speed dial",
          callerId: "Caller ID",
          unlockPrivate: "Unlock private number",
          callRecord: "Call record",
          reports: "Reports",
        },
        voicemailPanel: {
          activateVoicemail: "",
        },
      },
    },
  },
};

const i18n = new VueI18n({
  locale: "ru", //getDefaultLanguage(),//'ru',
  fallbackLocale: "en",
  messages: messages, //locales
  t: (key, ...params) => {
    i18n.t(key, params);
  },
});

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#b2b2b2", //"#F9F9FB", //grey
        secondary: "#d98372", // pink faded
        accent: "#CCB286", //golden
        error: "#B71C1C", //#FF5252", // red
        font: "#72635d",
        fontGrey: "#616161",
        grey: '#E0E0E0',
        fontDarkGrey: "#212121",
        information: "#2196F3", //starnge blue
        success: "#6e8f27", // #1B5E20//#939f71', //green
        successDark: '#1B5E20',
        warning: "#FFC107", //yellow
        background: "#fdfdfd",
        fadedSecondary: "#f7e5e2", //#FBF2F0
      },
      dark: {
        primary: "#ECEFF1",
        secondary: "#E0E0E0", // 
        accent: "#CCB286", //golden
        error: "#FF5252", // red
        information: "#2196F3", //starnge blue
        success: "#4CAF50", //green
        warning: "#FFC107",
        background: '#212121',//'#263238'
      },
    },
  },
  rtl: true,
  lang: {
    locales: { ru, he, en },
    lazy: true,
    current: "he",
    t: (key, ...params) => {
      i18n.t(key, params);
    },
  },
});
